import {
    GET_ADDRESS,
    EDIT_ADDRESS,
    ADD_ADDRESS,
    ALL_ADDRESS
  } from "./actionTypes"

  export const allAddress = address => {
    return {
      type: ALL_ADDRESS,
      payload: address,
    }
  }

  export const getAddress = (address) => {
    return {
      type: GET_ADDRESS,
      payload: {address},
    }
  }

  export const editAddress =  (address,history) => {
    return {
      type: EDIT_ADDRESS,
      payload: { address,history},
    }
  }

  export const addAddress =  (address,history) => {
    return {
      type: ADD_ADDRESS,
      payload: { address,history},
    }
  }